import * as carriers from '../../../InsuranceForm/carriers';
import { createSelector } from 'reselect';
import { insuranceTypeSelector } from '../insurance-type';

const carriersSelector = createSelector(
    state => state,
    insuranceTypeSelector,
    (state, insuranceType) => carriers.carriersSelector(state, insuranceType)
);

export default carriersSelector;
